import { TestimonialV3 } from "~/componentsDS/EnhancedTestimonials/data";

export const testimonialsData: TestimonialV3[] = [
    {
        type: "video-top",
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/v1767949729/Testimonials/Karen_L_vukoek.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/v1767949729/Testimonials/Karen_L_vukoek.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1775826019/Testimonials/Karen_L_Preview.webp",
        text: "I am concentrating and my critical thinking has improved...",
        author: "KAREN",
    },
    {
        type: "video-bottom",
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/v1767949730/Testimonials/Katie_V_w1yeeo.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/v1767949730/Testimonials/Katie_V_w1yeeo.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1775828838/Testimonials/Katie_V_Preview.webp",
        text: "Oestra's been life-changing, I have sex drive, my hair feels better, my skin feels better, I feel better overall. I cannot say enough.",
        author: "KATIE",
    },
    {
        type: "info",
        text: "I've been in menopause for the last five miserable years and tried pills, herbs, and oils with no positive results. \n \nAfter starting Oestra, I noticed a change within the week. Two months in, I finally have my libido back and intimacy is no longer painful. I'm so glad I have my life back again.",
        author: "PATRICIA",
        photo: "https://res.cloudinary.com/dirscuuhp/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1708702533/TESTIMONY%20WEBP/yevt3bmqq1hqt1xcz1fx.webp",
    },
    {
        type: "video-bottom",
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/v1767949719/Testimonials/Brigette_E_vkdvej.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/v1767949719/Testimonials/Brigette_E_vkdvej.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1775826449/Testimonials/Bridgette_Preview.webp",
        text: "I'm sleeping through the night, my hot flashes are completely gone, my hair is growing again... I definitely would recommend Oestra.",
        author: "BRIDGETTE",
    },
    {
        type: "info",
        text: "I'm four years post-menopause and this truly surprised me. It took about 11 days for my hot flashes to vanish and about 16 days for my libido to return. \n \nMy brain fog has been lifting, my joint pain is better, and my sleep has improved. The medical assistant team has also been phenomenal.",
        author: "ANDREA",
        photo: "https://res.cloudinary.com/dirscuuhp/image/upload/v1777972027/Testimonials/Avatar_-_Hayley_2_e2zveh.webp",
    },
    {
        type: "video-top",
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/v1767949730/Testimonials/Kathleen_F_ekuu1f.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/v1767949730/Testimonials/Kathleen_F_ekuu1f.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/c_crop,w_1038,h_1272,x_0,y_266/v1775826460/Testimonials/Kathleen_Preview.webp",
        text: "I'm not uncomfortable anymore. It also helps with my irritability.",
        author: "KATHLEEN",
    },
    {
        type: "double-info",
        feedbacks: [
            {
                text: "I already feel a lot of my pain decreasing, I'm sleeping better, and I'm able to mentally focus.",
                author: "ELANA",
                photo: "https://res.cloudinary.com/dirscuuhp/image/upload/v1748268372/UGC%20Videos/Elana_B_s6rynz.jpg",
                photoAlt: "Elana, verified Oestra® patient testimonial",
            },
            {
                text: "My creativity has come back, my brain fog has lifted, I feel more level energy day in and day out.",
                author: "MEGAN",
                photo: "https://res.cloudinary.com/dirscuuhp/image/upload/v1743762514/UGC%20Videos/Megan_R_ffzarx.webp",
                photoAlt: "Megan, verified Oestra® patient testimonial",
            },
        ]
    },
    {
        type: "video-bottom",
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/v1767949742/Testimonials/Rachael_B_jzplyz.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/v1767949742/Testimonials/Rachael_B_jzplyz.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1775826456/Testimonials/Rachel_B_Preview.webp",
        text: "I had already been dealing with PCOS. Same as perimenopause. I started getting hot flashes. Oestra has helped so much already.",
        author: "RACHEL",
    },
    {
        type: "info",
        text: "At 50, I started feeling the effects of menopause and struggled for years with weight gain, fatigue, anxiety, and no sex drive. \n \nWithin just one week of trying Inner Balance, I started feeling a real difference. After years of doctor appointments and trying everything, I'm so glad I gave it a chance. I only wish I had tried it sooner.",
        author: "LEIGH",
        photo: "https://res.cloudinary.com/dirscuuhp/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1708702540/TESTIMONY%20WEBP/lmj8rrhhbz66mif7ios2.webp",
    },
];

export const hrtTestimonialsData: TestimonialV3[] = [
    {
        type: "video-top",
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/v1765923395/UGC%20Videos/Marcia_O_cut_rm26cj.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/v1765923395/UGC%20Videos/Marcia_O_cut_rm26cj.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1748268371/UGC%20Videos/Marcia_O_jaciqf.webp",
        text: "I've lost weight, my energy is back, and my depression is gone...",
        author: "MARCIA",
    },
    {
        type: "video-bottom",
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/v1765923415/UGC%20Videos/Kiralee_J_cut_prh2ww.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/v1765923415/UGC%20Videos/Kiralee_J_cut_prh2ww.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1743762515/UGC%20Videos/Kiralee_J_f6scbb.webp",
        text: "The symptoms were just insane. I couldn't explain them, there was no reason for them. Fast forward... I finally found Inner Balance. It's like I'm waking up from a foggy dream.",
        author: "KIRALEE",
    },
    {
        type: "info",
        text: "In the first couple days that I took it, I had 110% energy back. My husband was like 'Whoa I haven't seen this in you in a really long time.' It just keeps getting better and better.",
        author: "HAYLEY",
        photo: "https://res.cloudinary.com/dirscuuhp/image/upload/v1765282113/new_design/Frame_1171277876_1_xlr0lp.webp",
        photoAlt: "Hayley, verified Oestra® patient testimonial",
    },
    {
        type: "video-top",
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/v1765923406/UGC%20Videos/Stacey_A_cut_ij2sqs.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/v1765923406/UGC%20Videos/Stacey_A_cut_ij2sqs.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1765924515/UGC%20Videos/Stacey_A_crop_1_oesmb0.webp",
        text: "I can honestly say that after 3 days, I said to my husband... I don't know how to explain it, but I feel myself again.",
        author: "STACEY",
        smallText: true,
    },
    {
        type: "double-info",
        feedbacks: [
            {
                text: "I already feel a lot of my pain decreasing, I'm sleeping better, and I'm able to mentally focus.",
                author: "ELANA",
                photo: "https://res.cloudinary.com/dirscuuhp/image/upload/v1748268372/UGC%20Videos/Elana_B_s6rynz.jpg",
                photoAlt: "Elana, verified Oestra® patient testimonial",
            },
            {
                text: "My creativity has come back, my brain fog has lifted, I feel more level energy day in and day out.",
                author: "MEGAN",
                photo: "https://res.cloudinary.com/dirscuuhp/image/upload/v1743762514/UGC%20Videos/Megan_R_ffzarx.webp",
                photoAlt: "Megan, verified Oestra® patient testimonial",
            },
        ]
    },
    {
        type: "video-top",
        mp4: "https://res.cloudinary.com/dirscuuhp/video/upload/v1765923396/UGC%20Videos/Jessica_K_cut_s3dcvg.mp4",
        hls: "https://res.cloudinary.com/dirscuuhp/video/upload/v1765923396/UGC%20Videos/Jessica_K_cut_s3dcvg.m3u8",
        poster: "https://res.cloudinary.com/dirscuuhp/image/upload/v1748268372/UGC%20Videos/Jessica_K_axbjjw.webp",
        text: "I absolutely adore Inner Balance. I started it and I feel amazing. It's been 6 months now. If you're thinking about it, stop thinking and just do it. You won't regret it.",
        author: "JESSICA",
        smallText: true,
    },
];
